var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_3329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 -10C39.482 -10 54.0213 -1.69129 62.6642 10.9645C62.8808 11.2818 62.7786 11.7149 62.446 11.907L33.3226 28.7216C33.1163 28.8407 32.8622 28.8407 32.6559 28.7216L28.3193 26.2178C18.7535 20.6949 6.5209 23.9722 0.998047 33.5381C-1.64123 38.1098 -2.26943 43.2903 -1.16287 48.0564C-1.09511 48.3483 -1.22162 48.6525 -1.48109 48.8024L-12.1738 54.9766C-12.764 55.3178 -12.5218 56.2207 -11.8398 56.2207H2.53405C2.7338 56.2207 2.9225 56.3107 3.05156 56.4631C4.50096 58.1754 6.26493 59.6723 8.31934 60.8584L24.2236 70.041C33.1933 75.2195 43.3835 76.3597 52.6962 74.0328C53.3928 73.8588 53.8896 74.7433 53.3335 75.1974C45.0655 81.9487 34.5067 86 23 86C-3.50967 86 -25 64.5097 -25 38C-25 11.4903 -3.50967 -10 23 -10Z",
    fill: "#111111",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_3329"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/3_2.adf59b8f7d8750b3f0e19baf1344b31c.svg";
export { ForwardRef as ReactComponent };